/** Textos da secção "footer". Chaves planas "footer.*"; "pt" é a fonte, "en" a tradução. */
const pt = {
    "footer.linkServers": "Servidores",
    "footer.linkVips": "VIPs",
    "footer.linkKits": "Kits",
    "footer.linkRules": "Regras",
    "footer.linkSupport": "Suporte",
    "footer.linkDiscord": "Discord",
    "footer.about":
        "Servidores Rust BR com foco em qualidade, wipes consistentes e uma comunidade presente.",
    "footer.navigate": "Navegar",
    "footer.community": "Comunidade",
    "footer.joinDiscord": "Entrar no Discord",
    "footer.ticketSupport": "Suporte ativo por ticket",
    "footer.rights": "© {year} ZRS — Zaralha Servers. Todos os direitos reservados.",
    "footer.status": "Rust BR · Wipe ativo",
};
const en = {
    "footer.linkServers": "Servers",
    "footer.linkVips": "VIPs",
    "footer.linkKits": "Kits",
    "footer.linkRules": "Rules",
    "footer.linkSupport": "Support",
    "footer.linkDiscord": "Discord",
    "footer.about":
        "Brazilian Rust servers focused on quality, consistent wipes and an active community.",
    "footer.navigate": "Navigate",
    "footer.community": "Community",
    "footer.joinDiscord": "Join Discord",
    "footer.ticketSupport": "Active support via tickets",
    "footer.rights": "© {year} ZRS — Zaralha Servers. All rights reserved.",
    "footer.status": "Rust BR · Wipe live",
};

export default { pt, en };
